import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";

const LeaveAvailable = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Fetch API
  const fetchLeaveAvailableReport = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_BASE_URL + "/leave_available_report", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      setRecords(res.data.records || []);
      toast.success("Leave availability loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (err) {
      toast.error("Failed to load leave availability report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveAvailableReport();
  }, []);

  // 🔹 Search filter
  const filteredRecords = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.department}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // 🔹 DataTable Columns
  const columns = [
    {
      name: "Employee ID",
      selector: row => row.employee_id,
      sortable: true,
    },
    {
      name: "Employee Name",
      selector: row => row.employee_name,
      sortable: true,
    },
    {
      name: "Department",
      selector: row => row.department,
      sortable: true,
    },
    {
      name: "Available CL",
      selector: row => row.available_cl,
      sortable: true,
      right: true,
    },
    {
      name: "Available SL",
      selector: row => row.available_sl,
      sortable: true,
      right: true,
    },
  ];

  // 🔹 Custom styles (optional)
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#7d858369",
        fontWeight: "bold",
        fontSize: "13px",
      },
    },
  };

  return (
    <div className="container-fluid mt-4">
      <ToastContainer />

      <div className="card">
        <h6 className="card-header text-danger">
          Employee Leave Availability
        </h6>

        <div className="card-body">
          {/* 🔸 Top controls */}
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <DownloadButtons
              data={filteredRecords}
              filename="Leave_Available_Report"
            />

            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              style={{ width: "220px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* 🔸 DataTable */}
          <DataTable
            columns={columns}
            data={filteredRecords}
            progressPending={loading}
            pagination
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            highlightOnHover
            striped
            dense
            customStyles={customStyles}
            noDataComponent={
              <div className="p-3 text-danger fw-bold">
                No records found
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveAvailable;
